import * as THREE from 'three';

/**
 * Creates a new geometry with only position and normal attributes
 */
export const filterGeometryAttributes = (geometry: THREE.BufferGeometry): THREE.BufferGeometry => {
  const filteredGeometry = new THREE.BufferGeometry();

  // Copy position attribute (required)
  const positionAttribute = geometry.getAttribute('position');
  if (positionAttribute) {
    filteredGeometry.setAttribute('position', positionAttribute.clone());
  }

  // Copy normal attribute if it exists
  const normalAttribute = geometry.getAttribute('normal');
  if (normalAttribute) {
    filteredGeometry.setAttribute('normal', normalAttribute.clone());
  }

  // Copy index if it exists
  if (geometry.index) {
    filteredGeometry.setIndex(geometry.index.clone());
  }

  return filteredGeometry;
};
